export default __webpack_public_path__ + "static/O0204-9b4e924fec531ccba6ce47ad60e1068a.png";